<template>
    <rkm-layout-body title="Lista de bairro">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-bairro-create' })"
                color="primary"
                authorize="store-cadastro-bairro"
            >
                Cadastrar bairro
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/bairro/List'

export default {
    components: { List },
}
</script>